import { HERO_BANNER_QUERY } from '@ecomm/city-state-data/lib/hero_banner_query'
import { useContentful } from '@ecomm/shared-apollo'
import { heroBannerSchema } from '@ecomm/shared-components/lib/HeroBanner/schema'
import { useMemo } from 'react'

export const useHeroBannerQuery = (bannerId: string) => {
  const { data: apolloData } = useContentful(HERO_BANNER_QUERY, {
    id: bannerId
  })
  const heroBannerData = useMemo(
    () => heroBannerSchema.parse(apolloData?.['heroBanner']),
    [apolloData]
  )
  return heroBannerData
}
